// extracted by mini-css-extract-plugin
export var centerText = "_bt-8";
export var container = "_bt-0";
export var doughnutContainer = "_bt-7";
export var legend = "_bt-a";
export var legendItemColorDisplay = "_bt-b";
export var legendItemLabel = "_bt-d";
export var legendItemValue = "_bt-c";
export var lg = "_bt-5";
export var maxWidth = "_bt-9";
export var md = "_bt-4";
export var responsive = "_bt-6";
export var sm = "_bt-3";
export var xs = "_bt-2";
export var xxs = "_bt-1";